import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/skin/c/lantern.svg'
import _imports_1 from '@/assets/images/skin/c/light-left.svg'
import _imports_2 from '@/assets/images/skin/c/ingot.svg'
import _imports_3 from '@/assets/images/skin/c/light-bottom.svg'
import _imports_4 from '@/assets/images/skin/c/ribbon.svg'
import _imports_5 from '@/assets/images/skin/c/redpack.svg'


const _withScopeId = n => (_pushScopeId("data-v-be9fa8ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "skin-slot-c",
  skin: "c"
}
const _hoisted_2 = { class: "tiger-container" }
const _hoisted_3 = { class: "tiger" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"lantern left\" data-v-be9fa8ec><img src=\"" + _imports_0 + "\" alt=\"\" data-v-be9fa8ec></div><div class=\"lantern right\" data-v-be9fa8ec><img src=\"" + _imports_0 + "\" alt=\"\" data-v-be9fa8ec></div><div class=\"light-left\" data-v-be9fa8ec><img src=\"" + _imports_1 + "\" alt=\"\" data-v-be9fa8ec></div><div class=\"ingot-left\" data-v-be9fa8ec><img src=\"" + _imports_2 + "\" alt=\"\" data-v-be9fa8ec></div><div class=\"light-bottom\" data-v-be9fa8ec><img src=\"" + _imports_3 + "\" alt=\"\" data-v-be9fa8ec></div>", 5)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"other-container\" data-v-be9fa8ec><div class=\"ribbon\" data-v-be9fa8ec><img src=\"" + _imports_4 + "\" alt=\"\" data-v-be9fa8ec></div><div class=\"redpack-top-left\" data-v-be9fa8ec><img src=\"" + _imports_5 + "\" alt=\"\" data-v-be9fa8ec></div><div class=\"ingot-bottom-container\" data-v-be9fa8ec><div class=\"ingot-bottom\" data-v-be9fa8ec><img src=\"" + _imports_2 + "\" alt=\"\" data-v-be9fa8ec></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tiger = _resolveComponent("tiger")!
  const _component_tiger_machine = _resolveComponent("tiger-machine")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("div", {
      class: "bg",
      style: _normalizeStyle(_ctx.phoneStyle)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_tiger)
        ]),
        _createVNode(_component_tiger_machine),
        _hoisted_4
      ]),
      _hoisted_9
    ], 4)
  ]))
}